import { Controller } from "@hotwired/stimulus"
import tinymce from "tinymce"
import "tinymce/icons/default"
import "tinymce/themes/silver"
import "tinymce/models/dom"
import "tinymce/plugins/link"
import "tinymce/plugins/lists"
import "tinymce/plugins/code"
import "../vendor/tinymce/langs/it"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    console.log("🟢 CONNECT", this.element.querySelector('textarea')?.id)
    
    // Piccolo delay per lasciar stabilizzare il DOM
    setTimeout(() => this.initTinymce(), 50)
  }

  disconnect() {
    console.log("🔴 DISCONNECT")
    // Rimuovi solo se l'elemento non è più nel DOM
    if (!document.contains(this.element)) {
      this.removeTinymce()
    }
  }

  initTinymce() {
    // Verifica che il controller sia ancora connesso
    if (!this.element.isConnected) {
      console.log("⚠️ Elemento non più nel DOM, skip init")
      return
    }

    const textarea = this.element.querySelector('textarea')
    if (!textarea) {
      console.error("❌ textarea non trovato")
      return
    }

    const id = textarea.id
    console.log("🚀 Init TinyMCE:", id)

    // Rimuovi istanza precedente
    tinymce.get(id)?.remove()

    tinymce.init({
      target: textarea,
      license_key: "gpl",
      language: "it",
      language_url: "/javascript/vendor/tinymce/langs/it.js",
      skin_url: "/assets/tinymce/skins/ui/oxide",
      content_css: "/assets/tinymce/skins/content/default/content.css",
      menubar: "format",
      branding: false,
      plugins: "link lists code",
      toolbar: "undo redo | styleselect | bold italic underline | bullist numlist | link | code",
      height: 300,
      setup: (editor) => {
        editor.on("init", () => console.log("✅ TinyMCE READY:", id))
        editor.on("change keyup", () => editor.save())
      }
    })
  }

  removeTinymce() {
    const textarea = this.element.querySelector('textarea')
    if (!textarea) return
    tinymce.get(textarea.id)?.remove()
  }
}